import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph, List } from "components/legal/LegalPageLayout.js";

export default () => {
  return (
    <LegalPageLayout
      productName="VIPSO"
      productUrl="/products/vipso"
      title="Privacy Policy"
      lastUpdated="July 10, 2026"
    >
      <Section>
        <Paragraph>
          <strong>Spurnest Techlabs</strong> built the <strong>VIPSO</strong> app as a commercial business application. This SERVICE is provided by Spurnest Techlabs and is intended for use as is.
        </Paragraph>
        <Paragraph>
          If you choose to use our Service, you agree to the collection and use of information in relation to this policy. Personal Information is used for providing and improving the Service. We will not use or share your information except as described in this Privacy Policy.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Information Collection and Use</SectionTitle>
        <Paragraph>
          For a better experience, we may require you to provide certain personally identifiable information. The information we request is retained and used as described in this policy.
        </Paragraph>
        <Paragraph>
          Subscription purchases are processed by Google Play. We do not have access to your personal billing information.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Sensitive Permissions</SectionTitle>
        <Paragraph>You may allow or prohibit the following permissions depending on features you use:</Paragraph>
        <List>
          <li><strong>CAMERA</strong> — taking pictures of modules and profiles.</li>
          <li><strong>READ_CONTACTS</strong> — importing Customer or Supplier data from your contacts list.</li>
          <li><strong>Local storage & Google Drive</strong> — We do not collect data stored locally or on Google Drive. We only provide an interface to select files for import. You can use the app without granting storage permissions.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Log Data & Analytics</SectionTitle>
        <Paragraph>
          In case of an error, we may collect Log Data through third-party products. This may include your device IP address, device name, operating system version, app configuration, and usage timestamps. We may use Firebase Analytics or similar services to improve app stability.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Advertising Identifiers</SectionTitle>
        <Paragraph>
          If advertising is enabled in future versions, the app may use your device's advertising identifier (GAID) to serve relevant ads through networks such as Google AdMob. You can reset or limit ad tracking in your device settings.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Service Providers</SectionTitle>
        <Paragraph>We may employ third parties to:</Paragraph>
        <List>
          <li>Facilitate and provide the Service on our behalf.</li>
          <li>Perform Service-related tasks.</li>
          <li>Assist in analyzing how the Service is used.</li>
        </List>
        <Paragraph>These parties have access to Personal Information only to perform tasks assigned to them and are obligated not to disclose or use it for other purposes.</Paragraph>
      </Section>

      <Section>
        <SectionTitle>Security</SectionTitle>
        <Paragraph>
          We strive to use commercially acceptable means to protect your information. No method of transmission or storage is 100% secure, and we cannot guarantee absolute security.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Children's Privacy</SectionTitle>
        <Paragraph>
          VIPSO is a business application not directed at children under 13. We do not knowingly collect personal information from children under 13. Contact us if you believe a child has provided us data.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Data Deletion</SectionTitle>
        <Paragraph>
          You may request deletion of your personal data by emailing{" "}
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>. We will process requests within 30 days.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Contact Us</SectionTitle>
        <Paragraph>
          Spurnest Techlabs, Gandhinagar, Gujarat 382610, India.
          <br />
          Email: <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>
          <br />
          Phone: <a href="tel:+918460407942" tw="text-primary-500 font-semibold">+91 84604 07942</a>
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
